import React from 'react';
interface ContentShellProps {
  children: React.ReactNode;
}
/**
 * ContentShell - Unified wrapper for all top-level pages
 * Applies consistent spacing for fixed header (pt-14) and sidebar (pl-56)
 */
export function ContentShell({
  children
}: ContentShellProps) {
  return <div className="ml-60 mt-14 min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950" data-main data-id="element-558">
      <div className="p-8" data-id="element-559">{children}</div>
    </div>;
}